export default {"src":"/_next/static/media/ABR.caff1028.svg","height":18,"width":18};